import { defineMessages } from 'react-intl';

export default defineMessages({
    removeInfo: {
        id: 'quoteandbind.PELLinedirectives.templates.Remove Material Handling, Waste Handling and Transportation',
        defaultMessage: 'Remove Material Handling, Waste Handling and Transportation',
    },
    removeInfoDesc: {
        id: 'quoteandbind.PELLinedirectives.templates.RawMaterialsDisposals',
        defaultMessage: 'Are you sure you want to remove this Material Handling, Waste Handling and Transportation from the list?',
    },
    rawMaterialsDisposalsInformation: {
        id: 'quoteandbind.PELLinedirectives.templates.Raw Materials Disposals Information',
        defaultMessage: 'Raw Materials Disposals Information'
    } 
});